import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../core/hooks/useAuth";
import { useMediaQuery } from "react-responsive";
import { theme } from "../../styles/theme";
import { getUserPermissions } from "../../utilities/permissions";

export { PublicRoute, PrivateRoute };

function PublicRoute({ children }) {
  const { isAuth } = useAuth();

  if (isAuth) {
    return <Navigate to="/projects" replace />;
  }

  return children;
}

function PrivateRoute({ children }) {
  const { isAuth } = useAuth();
  const location = useLocation();
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpoints.sm})` });

  const hasWeldingInspector = Object.values(getUserPermissions()).some(
    (role) => role.role === "Welding Inspector"
  );

  if (!isAuth) {
    return <Navigate to="/" replace />;
  }

  const isApplicationPath = location.pathname.startsWith("/application");
  const isAllowedDocumentDetail = /^\/documents\/[^\/]+\/detail\/[^\/]+\/?$/.test(
    location.pathname
  );

  if (isMobile) {
    if (isApplicationPath && !hasWeldingInspector && location.pathname !== "/projects") {
      return <Navigate to="/projects" replace />;
    }

    if (!isApplicationPath && !isAllowedDocumentDetail && hasWeldingInspector && location.pathname !== "/application") {
      return <Navigate to="/application" replace />;
    }
  } else {
    if (isApplicationPath && !hasWeldingInspector && location.pathname !== "/projects") {
      return <Navigate to="/projects" replace />;
    }
  }

  return children;
}

